export enum MarketPlaceStatusAsignationEnum {
    PENDIENTE      = 'PENDIENTE',
    REVICION       = 'REVICION',
    EN_NEGOCIACION = 'EN NEGOCIACION',
    FINALIZADO     = 'FINALIZADO',
}